import React from "react";

export const About: React.FC = () => {
  return (
    <section id="sobre" className="py-10 mx-4 lg:mx-0 flex justify-center">
      <div className="flex flex-col items-center justify-center lg:max-w-screen-md xl:max-w-screen-xl 2xl:max-w-screen-2xl space-y-10">
        {/* Seção Principal */}
        <div className="flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0 md:space-x-10 w-full">
          {/* Texto de Apresentação */}
          <div className="flex flex-col items-start space-y-4 md:w-1/2">
            <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold text-primary">
              O que cai no Enem?
            </h1>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed">
              Pela primeira vez, um projeto dedicado exclusivamente às provas do
              ENEM ganha vida. Com foco especial na área de Humanas, este site
              nasce da análise dos microdados do exame, organizando informações
              essenciais para alunos e professores. Aqui, você encontrará
              conteúdos acessíveis, gráficos detalhados e uma abordagem clara
              para entender melhor as demandas dessa modalidade de prova. Um
              espaço feito para quem busca conhecimento com precisão e
              relevância.
            </p>
            {/* <button className="mt-4 px-6 py-3 bg-primary text-white font-medium rounded-full shadow-md hover:bg-primary-dark">
              Receba atualizações
            </button> */}
          </div>

          {/* Imagem com Botão */}
          <div className="relative md:w-2/5">
            <div className="overflow-hidden rounded-2xl shadow-lg">
              <img
                src={require("../../assets/sobre-enem.jpeg")}
                alt="Apresentação de aula"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
